import React, { useState, useEffect } from "react";
import Service from "../../Service/firebase";
import firebase from "../../firebase";
import { format } from "date-fns";

const AddStylist = (props) => {
  const [imageFile, setImageFile] = useState(null);
  const [htmlElement, setHtmlElement] = useState(
    <i className="fa fa-user fa-8x" aria-hidden="true"></i>
  );
  const [isLoading, setIsLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [vendorCode, setVendorCode] = useState("");
  const [vendorCodeError, setVendorCodeError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    role: "",
    experience: "",
    vendorId: "",
    active: true,
    addedOn: format(new Date(), "d-M-yyyy"),
  });

  useEffect(() => {
    Service.getAllData("vendors").then((list) => {
      if (list.length > 0) setVendors(list);
    });
  }, []);

  const onEdit = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleVendorCodeBlur = () => {
    if (vendorCode) {
      const found = vendors.find((v) => v.vendorCode === vendorCode);
      if (found) {
        setFormData((prev) => ({ ...prev, vendorId: found.uid }));
        setVendorCodeError("");
      } else {
        setFormData((prev) => ({ ...prev, vendorId: "" }));
        setVendorCodeError("Vendor code not found");
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (imageFile) {
      onUploadImage(imageFile);
    } else {
      onAddStylist("");
    }
  };

  const onUploadImage = async (image) => {
    const url = await Service.uploadImage(image, "stylistImages");
    if (url !== "") {
      onAddStylist(url);
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  const onAddStylist = async (imageUrl) => {
    const sendData = {
      ...formData,
      image: imageUrl,
      searchbyname: formData.name.toLowerCase().replace(/\s/g, ""),
      createdTime: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    const res = await Service.addData(sendData, "stylists", "stylistId");
    if (res === "success") {
      const vendor = vendors.find((v) => v.uid === formData.vendorId);
      if (vendor && !vendor.stylists) {
        await Service.updateData({ stylists: true }, "vendors", vendor.uid);
      }
      setIsLoading(false);
      props.handleSuccessDailog();
    } else {
      setIsLoading(false);
      props.handleErrorDailog();
    }
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (e) => {
        setHtmlElement(
          <img
            style={{ width: 100, height: 100, borderRadius: "50%", objectFit: "cover" }}
            src={e.target.result}
            alt="stylist"
          />
        );
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  return isLoading ? (
    <div style={{ textAlign: "center", padding: 40 }}>
      <i className="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
  ) : (
    <div style={{ padding: "16px" }}>
      <form onSubmit={handleSubmit}>
        {/* Image */}
        <div className="form-group text-center">
          <div style={{ marginBottom: 8 }}>{htmlElement}</div>
          <input type="file" accept="image/*" onChange={onImageChange} />
        </div>

        {/* Vendor Code */}
        <div className="form-group">
          <label>Vendor Code <span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter vendor code"
            value={vendorCode}
            onChange={(e) => setVendorCode(e.target.value)}
            onBlur={handleVendorCodeBlur}
            required
          />
          {vendorCodeError && <small style={{ color: "red" }}>{vendorCodeError}</small>}
          {formData.vendorId && !vendorCodeError && (
            <small style={{ color: "green" }}>
              {vendors.find((v) => v.uid === formData.vendorId)?.salonName || "Vendor found"}
            </small>
          )}
        </div>

        {/* Name */}
        <div className="form-group">
          <label>Name <span style={{ color: "red" }}>*</span></label>
          <input
            name="name"
            type="text"
            className="form-control"
            value={formData.name}
            onChange={onEdit}
            required
          />
        </div>

        {/* Role */}
        <div className="form-group">
          <label>Role <span style={{ color: "red" }}>*</span></label>
          <input
            name="role"
            type="text"
            className="form-control"
            placeholder="e.g. Makeup Artist, Hair Stylist"
            value={formData.role}
            onChange={onEdit}
            required
          />
        </div>

        {/* Experience */}
        <div className="form-group">
          <label>Experience</label>
          <input
            name="experience"
            type="text"
            className="form-control"
            placeholder="e.g. 5 Years"
            value={formData.experience}
            onChange={onEdit}
          />
        </div>

        {/* Active */}
        <div className="form-group form-check">
          <input
            name="active"
            type="checkbox"
            className="form-check-input"
            id="activeCheck"
            checked={formData.active}
            onChange={onEdit}
          />
          <label className="form-check-label" htmlFor="activeCheck">Active</label>
        </div>

        <div className="d-flex" style={{ gap: 8 }}>
          <button type="submit" className="btn btn-primary">Save</button>
          <button type="button" className="btn btn-secondary" onClick={props.handleErrorDailog}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddStylist;
